import type { Icon } from '@phosphor-icons/react';
import { CurrencyCircleDollar } from '@phosphor-icons/react';

/**
 * La lista de pasos numerados del programa de heru-cash: badge con ícono,
 * número encimado, título, descripción y una pastilla verde opcional para el
 * dato que el usuario se tiene que llevar.
 *
 * NO ES UN COMPONENTE NUEVO, ES EL DE REFERIDOS MUDADO. El markup nació en
 * `ReferralsModal/ReferralsContent` y el explicador de heru-cash necesitaba el
 * mismo: en vez de copiarlo —y verlo divergir al primer ajuste de diseño—
 * vive aquí y lo consumen los dos. Está en molecules porque el explicador se
 * monta desde las pantallas PURAS de onboarding v3, que sólo pueden importar
 * de esa allowlist (purity.test.ts).
 *
 * PURO: recibe los pasos ya armados y no decide nada.
 */
export type NumberedStep = {
	icon: Icon;
	title: string;
	desc?: string;
	/** Pastilla verde bajo la descripción: el número que importa (el monto
	 * prometido, el porcentaje del referido). Opcional a propósito — sólo un
	 * paso de la lista suele merecerla. */
	reward?: string;
};

const NumberedSteps = ({ steps }: { steps: NumberedStep[] }) => (
	<div className='mb-5 flex flex-col gap-3.5'>
		{steps.map((step, i) => {
			const Icon = step.icon;
			return (
				<div key={step.title} className='flex items-start gap-3'>
					<div className='relative flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-h-primary-95 text-h-primary-30'>
						<Icon size={22} weight='duotone' />
						<span className='absolute -top-1.5 -right-1.5 flex h-[18px] w-[18px] items-center justify-center rounded-full border-2 border-white bg-h-primary-30 text-[10px] font-extrabold text-white'>
							{i + 1}
						</span>
					</div>
					<div className='pt-0.5'>
						<div className='text-[13.5px] leading-snug font-semibold text-h-text-heading'>
							{step.title}
						</div>
						{step.desc && (
							<div className='mt-0.5 text-xs leading-snug text-h-text-medium'>
								{step.desc}
							</div>
						)}
						{step.reward && (
							<span className='mt-1.5 inline-flex items-center gap-1.5 rounded-full bg-h-success-90 px-2.5 py-1 text-[10.5px] font-bold text-h-success-30'>
								<CurrencyCircleDollar size={13} weight='fill' />
								{step.reward}
							</span>
						)}
					</div>
				</div>
			);
		})}
	</div>
);

export default NumberedSteps;
